import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid", "onClick", "onKeydown"]
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buckets, (bucket, bIndex) => {
      return (_openBlock(), _createElementBlock("section", {
        key: bIndex,
        class: "provider-grid__bucket"
      }, [
        (bucket.label)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "provider-grid__bucket-label",
              "data-testid": bucket.labelTestId || undefined
            }, _toDisplayString(bucket.label), 9, _hoisted_1))
          : _createCommentVNode("", true),
        _createElementVNode("ul", {
          class: _normalizeClass(["provider-grid__grid", { 'provider-grid__grid--single': bucket.items.length === 1 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bucket.items, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.key,
              class: _normalizeClass(["v1-group__cell", {
            'v1-group__cell--selected': _ctx.selectedKey === item.key,
            'v1-group__cell--dimmed': item.dimmed,
          }]),
              role: "button",
              tabindex: 0,
              "data-testid": item.testId,
              onClick: ($event: any) => (_ctx.$emit('select', item.key)),
              onKeydown: [
                _withKeys(_withModifiers(($event: any) => (_ctx.$emit('select', item.key)), ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.$emit('select', item.key)), ["prevent"]), ["space"])
              ]
            }, [
              _createElementVNode("img", {
                src: item.logoUrl,
                alt: item.alt,
                class: "v1-group__logo"
              }, null, 8, _hoisted_3)
            ], 42, _hoisted_2))
          }), 128))
        ], 2)
      ]))
    }), 128))
  ]))
}